/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadDokumentTypMiniDto } from '../../models/lexplus-upload-dokument-typ-mini-dto';

export interface UploadDokumentTypeControllerFindV1$Params {
  id?: string;
  parentId?: string;
  parentLabelKey?: string;
}

export function uploadDokumentTypeControllerFindV1(http: HttpClient, rootUrl: string, params?: UploadDokumentTypeControllerFindV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusUploadDokumentTypMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, uploadDokumentTypeControllerFindV1.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('parentId', params.parentId, {});
    rb.query('parentLabelKey', params.parentLabelKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusUploadDokumentTypMiniDto>>;
    })
  );
}

uploadDokumentTypeControllerFindV1.PATH = '/v1/upload-dokument-type';
